import { useState } from 'react'
import Button from '../../Atoms/Button/Button';
import { Table } from "antd";
import PhoneSvg from '../../Atoms/PhoneSvg/PhoneSvg'
import VentasSvg from '../../Atoms/VentasSvg/VentasSvg'
import { useLocation } from 'wouter';
import './CampainsTable.scss'
import Modal from '../../Organisms/Modal/Modal';
import fetchCampains from './campainsJSON.json'
import iconWarning from '../../../assets/warning.svg'
import iconSuccess from '../../../assets/icon-check-success.svg'
import { useModal } from "../../../customHooks/useModal";

const columns = [
  {
    title: 'Nombre y Apellido',
    dataIndex: 'content',
    key: 'content',
  },
  {
    title: 'Costo diario',
    dataIndex: 'priceday', 
    key: 'priceday',
  },
  {
    title: 'Costo total',
    dataIndex: 'pricetotal', 
    key: 'pricetotal',
  },
  {
    title: 'Acciones',
    dataIndex: 'actions', 
    key: 'actions',
    fixed: 'right',
  },
];

const CampainsTable = ({ active, inactive, draft}) => {
  const [isOpenModalSuspend, openModalSuspend, closeModalSuspend] = useModal(false)
  const [isOpenModalDelete, openModalDelete, closeModalDelete] = useModal(false)
  const [isOpenModalSuspendSuccess, openModalSuspendSuccess, closeModalSuspendSuccess] = useModal(false)
  const [isOpenModalDeleteSuccess, openModalDeleteSuccess, closeModalDeletedSuccess] = useModal(false)
  const [, setLocation] = useLocation()
  const [countRowSelection, setCountRowSelection] = useState(0)
  const campainsList = []

  // Modal para confirmar Suspender una campaña
  const openModalSuspendCampaign = (idCampaign) => {
    console.log('idCampaing', idCampaign) // id de la campaña a suspender
    openModalSuspend()
  }

   // Modal para confirmar eliminar una campaña
  const openModalDeleteCampaign = () => {
    openModalDelete()
  }

  // Suspender una campaña
  const suspendCampaign = () => {
    closeModalSuspend()
    openModalSuspendSuccess()
  }

  // Eliminar campaña
  const deleteCampaign = () => {
    closeModalDelete()
    openModalDeleteSuccess()
  }

  // Fake Fetching
   fetchCampains.campains.forEach(campain => 
    campainsList.push({
      key: campain.id,
      content: 
      <>
      <div className="campain-item__content">
        <h2 className="source-20 bold mb-10 text-ellipsis" htmlFor="checkbox">{campain.name}</h2>
        <p className="source-16 semi-bold mb-10 text-ellipsis"><span className="source-16 sm-bold">Descripcion:</span>{campain.description}</p>
        <p className="source-16 semi-bold mb-10 text-ellipsis"><span className="source-16  sm-bold">Perfiles asignados:</span> {campain.profiles}</p>
        <div className="campain-item__capsules">
          <div className="campain-item__capsule light-blue">
            <PhoneSvg />
            <span>Inbound</span>
          </div>
          <div className="campain-item__capsule gray">
            <VentasSvg />
            <span>Ventas</span>
          </div>
        </div>
        <div className="mt-10 campain-item__date">
          <p className="source-16 sm-bold">Inicio: {campain.init}</p>
          <p className="source-16 sm-bold">Finalización: {campain.finish}</p>
        </div>
      </div>
      </>,
      priceday:  <p className="source-16">USD ${campain.priceday}</p>,
      pricetotal: <p className="source-16">USD ${campain.pricetotal}</p>,
      actions: <div>
                  <Button content="Editar" customClass="s-large m-auto mb-15" type="primary outline" clickHandler={() => setLocation('/campaigns/gestionar/editar')}/>
                  <Button content="Suspender" customClass="s-large m-auto" type="grayColor" clickHandler={() => openModalSuspendCampaign(campain.id)}/>
                </div>
    })
  )

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setCountRowSelection(selectedRows.length)
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };

  return (
    <>
    <div className="nd-grid box s-pxy-20 m-pxy-50 ">
      <div className="header_campaign_table mb-20">
        {active && <p className="source-24 ">Lista de campañas activas</p>}
        {inactive && <p className="source-24 ">Lista de campañas inactivas</p>}
        {draft && <p className="source-24 ">Lista de campañas en borrador</p>}
        <button onClick={() => openModalDeleteCampaign()} disabled={countRowSelection > 0 ? false : true} className="button s-large m-auto grayColor outline" >
          Eliminar seleccionada(s)
        </button>
      </div>
      <div className="table-container">
        <Table 
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }} 
          columns={columns} 
          dataSource={campainsList}
          pagination={false}
        />
      </div>
    </div>
      
      {/* Modal confirmar suspender campaña */}
      <Modal
        isOpenModal={isOpenModalSuspend}
        closeModal={closeModalSuspend}
        iconModal={iconWarning}
        titleModal="Cuidado" 
        subTitleModal="Estas a punto de suspender esta campaña ¿confirmas esta acción?"
      >
        <div className="buttons-container center">
          <Button content="Si, suspender" customClass="s-large m-auto" type="primary" clickHandler={() => suspendCampaign()}/>
          <Button content="Cancelar" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalSuspend()}/>   
        </div>
      </Modal>

      {/* Modal confirmar eliminar campaña */}
      <Modal
        isOpenModal={isOpenModalDelete}
        closeModal={closeModalDelete}
        iconModal={iconWarning}
        titleModal="Cuidado" 
        subTitleModal="Estas a punto de eliminar esta campaña ¿confirmas esta acción?"
      >
        <div className="buttons-container center">
          <Button content="Si, eliminar" customClass="s-large m-auto" type="primary" clickHandler={() => deleteCampaign()}/>
          <Button content="Cancelar" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalDelete()}/>   
        </div>
      </Modal>

      {/* Modal success suspender campaña */}
      <Modal
        isOpenModal={isOpenModalSuspendSuccess}
        closeModal={closeModalSuspendSuccess}
        iconModal={iconSuccess}
        titleModal="¡Listo!" 
        subTitleModal="Campaña suspendida"
      >
        <div className="buttons-container center">
          <Button content="Ir a campañas" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalSuspendSuccess()}/>   
        </div>
      </Modal>

      {/* Modal success eliminar campaña */}
      <Modal
        isOpenModal={isOpenModalDeleteSuccess}
        closeModal={closeModalDeletedSuccess}
        iconModal={iconSuccess}
        titleModal="¡Listo!" 
        subTitleModal="Campaña eliminada"
      >
        <div className="buttons-container center">
          <Button content="Ir a campañas" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalDeletedSuccess()}/>   
        </div>
      </Modal>
    </>
  )
}
export default CampainsTable
